import React from 'react';
import { useNavigate } from 'react-router';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';

import { SearchStringProvider, useSearchString } from '@barboxx/admin-utils';
import { Can } from '@barboxx/react-utils';

import {
    CustomPageHeader,
    RootContainer,
} from '../../components/nav/RootContainer';
import { BusinessesTable } from './components/BusinessesTable';

function BusinessesListCard() {
    const navigate = useNavigate();
    const { InputComponent, searchString } = useSearchString();

    const handleAddClick = React.useCallback(() => {
        navigate('/places');
    }, [navigate]);

    const CustomPageToolbarComponent = React.useCallback(
        () => (
            <CustomPageHeader>
                <Box gap={2} flexDirection="row" display="flex">
                    <InputComponent />
                    <Can I="create" a="Business">
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={handleAddClick}
                        >
                            Add Business
                        </Button>
                    </Can>
                </Box>
            </CustomPageHeader>
        ),
        [InputComponent, handleAddClick]
    );

    return (
        <RootContainer
            maxWidth={false}
            slots={{ header: CustomPageToolbarComponent }}
        >
            <BusinessesTable searchString={searchString} />
        </RootContainer>
    );
}

export function BusinessesList() {
    return (
        <SearchStringProvider>
            <BusinessesListCard />
        </SearchStringProvider>
    );
}
